<template>
    <router-link :to="typeRoute" class="type-link">{{ label || type.caption }}</router-link>
</template>

<script>
  import Type            from '../../modules/Elements/Type';
  import { ROUTE_TYPES } from '../../router';

  export default {
    name: 'TypeLink',

    props: {
      type: {
        type:     Object,
        required: true,
      },

      label: {
        type:     String,
        required: false,
      },
    },

    computed: {
      typeRoute () {
        return {
          name: ROUTE_TYPES,
          hash: `#type-${ this.type.name }`,
        };
      },
    },
  };
</script>

<style scoped>
    .type-link {
        padding:         2px 6px;
        border-radius:   3px;
        text-decoration: none;
        color:           var(--color-primary);
        background:      rgba(0, 0, 0, 0.025);
        transition:      all 0.125s;
        word-break:      keep-all;
        white-space:     nowrap;
    }

    .type-link:hover {
        color:      var(--color-primary-highlight);
        background: rgba(0, 0, 0, 0.05);
    }
</style>
